import { isNull } from '@/utils/dataUtil';
import { IDENTITY_API, STRUCTURES_API } from '@/api';

class SppStore {
    constructor() {
        this.marketParticipant = null;
        this.assetOwner = null;
        this.meterAgent = null;
        this.locationGroupId = null;
        this.locationGroupName = null;
    }

    getDefaults() {
        return {
            marketParticipant: null,
            assetOwner: null,
            meterAgent: null,
            locationGroupId: null,
            locationGroupName: null,
        };
    }

    setDefaults(model) {
      const settings = isNull(model, this.getDefaults());
      this.assetOwner = isNull(settings.assetOwner, null);
      this.marketParticipant = isNull(settings.marketParticipant, null);
      this.meterAgent = isNull(settings.meterAgent, null);
      this.locationGroupId = isNull(settings.locationGroupId, null);
      this.locationGroupName = isNull(settings.locationGroupName, null);
    }

    getAssetOwner() {
        return this.assetOwner;
    }

    getMarketParticipant() {
        return this.marketParticipant;
    }

    getMeterAgent() {
        return this.meterAgent;
    }

    getLocationGroupId() {
        return this.locationGroupId;
    }

    getLocationGroupName() {
        return this.locationGroupName;
    }

    async fetchAssetOwners() {
        try {
            const { data: { entities: assetOwners } } = await IDENTITY_API.get('/entities?entityType=SPP_AO');
            return assetOwners.map(ao => ao.name).sort();
        } catch (error) {
            console.error(error);
        }
        return [];
    }

    async fetchMarketParticipants() {
        try {
            const { data: { entities: marketParticipants } } = await IDENTITY_API.get('/entities?entityType=SPP_MP');
            return marketParticipants.map(mp => mp.name).sort();
        } catch (error) {
            console.error(error);
        }
        return [];
    }

    async fetchMeterAgents() {
        try {
            const { data: { entities: meterAgents } } = await IDENTITY_API.get('/entities?entityType=SPP_MA');
            return meterAgents.map(ma => ma.name).sort();
        } catch (error) {
            console.error(error);
        }
        return [];
    }

    async fetchLocationGroups() {
        try {
            const { data: { locationGroups } } = await STRUCTURES_API.get('/location-groups');
            return locationGroups.map(lg => ({ label: lg.shortName, value: lg.id })).sort((a, b) => a.label.localeCompare(b.label));
        } catch (error) {
            console.error(error);
        }
        return [];
    }
}

const sppStore = new SppStore();
export default sppStore;